import { getApis } from './core';

export const signIn = async () => {
  const { googleIdentity } = getApis();
  
  return new Promise((resolve, reject) => {
    try {
      if (!googleIdentity) {
        return reject(new Error('Google Identity Services not initialized.'));
      }
  
      googleIdentity.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        auto_select: true,
        use_fedcm_for_prompt: true,
        callback: (response) => {
          if (response.error || !response.credential) {
            reject(new Error(response.error));
          } else {
            resolve(response.credential);
          }
        },
      });
  
      googleIdentity.prompt((notification) => {
        if (notification.isSkippedMoment()) {
          return reject(new Error('Google Sign-In was skipped. If this wasn\'t intentional, please try again or check your browser\'s security settings.'));
        }
      });
    } catch (error) {
      console.log('Error in signIn:', error);
      reject(error);
    }
  });
};
